'use strict';

/** @type {Promise} **/
module.exports = typeof Promise === 'function' ? Promise : require('es6-promise').Promise;



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger-parser/lib/promise.js
 ** module id = 227
 ** module chunks = 0
 **/